export const formatDateToTimeString = date => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
    const h = String(date.getHours()).padStart(2, '0');
    const m = String(date.getMinutes()).padStart(2, '0');
    return `${h}:${m}`;
};
